"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var index_1 = require("superdesk-core/scripts/index");
setTimeout(index_1.startApp);
exports.default = angular_1.default.module('lji', [])
    .run(['$templateCache', function ($templateCache) {
        $templateCache.put('scripts/core/menu/views/about.html', require('./views/about.html'));
    }]);



//////////////////
// WEBPACK FOOTER
// ./lji/index.js
// module id = 2489
// module chunks = 0